module.exports = __webpack_public_path__ + "static/okPhotoPhone-9b828a25412bfdf098d25f5f6ce27566.png";